import React, { useState } from "react";
import { useCart } from "@/contexts/CartContext";
import { Plus, Minus, ShoppingCart } from "lucide-react";

/**
 * Compact add-to-cart cell for the tarifs table.
 * Shows a quantity stepper + "Ajouter" button, disabled when price is null (sur demande).
 */
export default function AddToCartControl({ item }) {
    const { addItem } = useCart();
    const [qty, setQty] = useState(1);
    const disabled = item.prix_kg_ht == null;

    if (disabled) {
        return <span className="text-xs text-[#A0A0A0] italic">Sur demande</span>;
    }

    const bump = (delta) => setQty((q) => Math.max(0.5, +(q + delta).toFixed(2)));

    return (
        <div className="flex items-center gap-2" data-testid={`add-controls-${item.id}`}>
            <div className="flex items-center border" style={{ borderColor: "var(--bc-border-strong)" }}>
                <button
                    type="button"
                    onClick={() => bump(-0.5)}
                    className="px-2 py-1 text-[#D4BC7C] hover:bg-[#0a0a0a]"
                    aria-label="Diminuer"
                    data-testid={`qty-minus-${item.id}`}
                >
                    <Minus size={12} />
                </button>
                <input
                    type="number"
                    step="0.5"
                    min="0.5"
                    value={qty}
                    onChange={(e) => setQty(Math.max(0.5, Number(e.target.value) || 0.5))}
                    className="w-14 text-center bg-transparent text-[#F2ECE0] text-sm py-1 focus:outline-none"
                    style={{ appearance: "textfield" }}
                    data-testid={`qty-input-${item.id}`}
                />
                <button
                    type="button"
                    onClick={() => bump(0.5)}
                    className="px-2 py-1 text-[#D4BC7C] hover:bg-[#0a0a0a]"
                    aria-label="Augmenter"
                    data-testid={`qty-plus-${item.id}`}
                >
                    <Plus size={12} />
                </button>
            </div>
            <button
                type="button"
                onClick={() => addItem(item, qty)}
                className="bc-btn bc-btn--sm"
                data-testid={`add-cart-${item.id}`}
            >
                <ShoppingCart size={12} />
            </button>
        </div>
    );
}
